import React from 'react';
import {Dialog, DialogTitle, withStyles, WithStyles} from '@material-ui/core';

import {useDispatch, useSelector} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import {ChangePassword} from '../../containers';

import {types as authActionTypes} from '../../actions/auth/actionTypes';
import {AppStoreType} from '../../utils/store';

import {style} from './style';

type RequirePasswordChangeModalProps = WithStyles<typeof style>

function RequirePasswordChangeModal({
  classes,
}: RequirePasswordChangeModalProps) {
  const dispatch = useDispatch();

  const isPasswordChangeRequired =
    useSelector((store: AppStoreType) => store.authReducer.isPasswordChangeRequired);

  return (
    <Dialog
      classes={{paper: classes.modal}}
      fullWidth={true}
      maxWidth="sm"
      open={isPasswordChangeRequired}
      onClose={() => { }}
    >
      <DialogTitle>{I18n.t('requiredPasswordChangeModal.title')}</DialogTitle>
      <ChangePassword
        // @ts-ignore: incorrect getting of prop types from js files
        onChangeSuccess={() => {
          dispatch({
            type: authActionTypes.SET_IS_PASSWORD_CHANGE_REQUIRED,
            isPasswordChangeRequired: false,
          });
          window.location.reload();
        }}
        customCardClass="card_noOutline"
      />
    </Dialog>
  );
}

export default withStyles(style)(RequirePasswordChangeModal);
